import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import lottie from "lottie-web";
import AOS from "aos";
import "aos/dist/aos.css";

import brandTitleNew from "../animations/hero/brand-title-new.json";
import aiFilmmaking from "../animations/hero/ai-filmmaking.json";
import wealthMgmt from "../animations/hero/wealth-management.json";
import bizAutomation from "../animations/hero/business-automation.json";
import remedialEdu from "../animations/hero/remedial-education.json";
import ugcLogo from "../animations/hero/ugc-logo.json";

import empowering from "../animations/datacollection/empowering.json";

import heroImg1 from "../images/hero-banner-title-image1.webp";
import heroImg2 from "../images/2 AI Filmmaking.webp";
import heroImg3 from "../images/3 Remedial Teaching.webp";
import heroImg4 from "../images/4 Wealth Management.webp";
import heroImg5 from "../images/5 Business Automation.webp";
import datacollectionImg from "../images/datacollection image.webp";
import cardImg from "../images/Ai_card_img.png";
import genlogo from "../images/GEN_SKILL_COLLEGE_LOGO.png";

const heroAnimations = [brandTitleNew, aiFilmmaking, remedialEdu, wealthMgmt, bizAutomation];
const heroImages = [heroImg1, heroImg2, heroImg3, heroImg4, heroImg5];

const courses = [
  { title: "AI Filmmaking", desc: "Master the art of filmmaking powered by artificial intelligence. Learn to create stunning visuals, automate editing, and produce professional content." },
  { title: "Remedial Education", desc: "Specialized teaching methodologies designed to bridge learning gaps and empower students with personalized educational approaches." },
  { title: "Wealth Management", desc: "Gain expertise in financial planning, investment strategies, and portfolio management to build and protect wealth." },
  { title: "Business Automation", desc: "Learn to streamline operations using AI and automation tools, reducing costs and boosting productivity for modern enterprises." },
  { title: "Digital Marketing", desc: "Master SEO, social media, content marketing, and paid advertising to drive growth in the digital economy." },
  { title: "Data Analytics", desc: "Transform raw data into actionable insights using modern analytical tools and visualization techniques." },
];

const partners = [
  { id: 1, src: genlogo, alt: "Partner 1" },
  { id: 2, src: genlogo, alt: "Partner 2" },
  { id: 3, src: genlogo, alt: "Partner 3" },
  { id: 4, src: genlogo, alt: "Partner 4" },
  { id: 5, src: genlogo, alt: "Partner 5" },
  { id: 6, src: genlogo, alt: "Partner 6" },
];

const stats = [
  { icon: "bi-mortarboard", value: "5000+", label: "Students Enrolled" },
  { icon: "bi-building", value: "50+", label: "Industry Partners" },
  { icon: "bi-award", value: "95%", label: "Placement Rate" },
  { icon: "bi-globe", value: "20+", label: "Programs Offered" },
];

function Home() {
  const lottieContainer = useRef(null);
  const empowerRef = useRef(null);
  const ugcRef = useRef(null);
  const [currentAnim, setCurrentAnim] = useState(0);
  const [showVideo, setShowVideo] = useState(false);
  const [slideState, setSlideState] = useState('in');
  const [showButtons, setShowButtons] = useState(false); // 'in', 'out'

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  useEffect(() => {
    let anim;
    
    // Delay lottie start until slide animation completes
    const timer = setTimeout(() => {
      const isMobile = window.innerWidth < 768;
      anim = lottie.loadAnimation({
        container: lottieContainer.current,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: heroAnimations[currentAnim],
        rendererSettings: {
          preserveAspectRatio: isMobile ? 'xMidYMid meet' : 'xMinYMid meet'
        }
      });

      // Speed up animation to fit ~8 seconds total
      anim.setSpeed(2.2);

      // Show buttons immediately when text becomes visible
      if (currentAnim !== 0) {
        setTimeout(() => {
          setShowButtons(true);
        }, 1700);
      }

      anim.addEventListener('complete', () => {
        if (currentAnim !== 0) {
          setTimeout(() => {
            setShowButtons(false);
            setSlideState('out');
            setTimeout(() => {
              setCurrentAnim((prev) => (prev + 1) % heroAnimations.length);
              setSlideState('in');
            }, 350);
          }, 2000);
        } else {
          setSlideState('out');
          setTimeout(() => {
            setCurrentAnim((prev) => (prev + 1) % heroAnimations.length);
            setSlideState('in');
          }, 350);
        }
      });
    }, 400);

    return () => {
      clearTimeout(timer);
      if (anim) anim.destroy();
    };
  }, [currentAnim]);

  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: empowerRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: empowering,
    });
    return () => anim.destroy();
  }, []);

  useEffect(() => {
    if (ugcRef.current) {
      const anim = lottie.loadAnimation({
        container: ugcRef.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: ugcLogo,
      });
      return () => anim.destroy();
    }
  }, [currentAnim]);

  const repeatedLogos = [...partners, ...partners, ...partners];

  return (
    <>
      {/* HERO SECTION */}
      <section className="hero-section">
        <div className="container-fluid">
          <div className={`row align-items-center hero-content px-md-5 px-3 hero-slide-${slideState}`}>
            <div className={`col-md-8 slide-text mb-4 mb-md-0 ${currentAnim === 0 ? 'order-1 order-md-1' : 'order-2 order-md-1'}`}>
              <div ref={lottieContainer} className="lottie-hero" key={`lottie-${currentAnim}`}></div>
              {currentAnim !== 0 && (
                <div className={`btn-group-row mt-3 ${showButtons ? 'btn-visible' : 'btn-hidden'}`}>
                  <Link to="/courses" className="join-btn">Enquire Now</Link>
                  <Link to="/about" className="more-btn">View Details</Link>
                </div>
              )}
            </div>
            <div className={`col-md-4 slide-img ${currentAnim === 0 ? 'order-2 order-md-2' : 'order-1 order-md-2'}`}>
              <img src={heroImages[currentAnim]} className="img-fluid floating-img" alt="Hero" key={`img-${currentAnim}`} />
              {currentAnim === 0 && <div ref={ugcRef} className="ugc-logo-anim"></div>}
            </div>
          </div>
        </div>

        <div className="hero-dots">
          {heroAnimations.map((_, index) => (
            <button
              key={index}
              className={`hero-dot ${currentAnim === index ? 'active' : ''}`}
              onClick={() => {
                setShowButtons(false);
                setSlideState('out');
                setTimeout(() => {
                  setCurrentAnim(index);
                  setSlideState('in');
                }, 350);
              }}
            />
          ))}
        </div>

        <button className="hero-arrow hero-arrow-left" onClick={() => {
          setShowButtons(false);
          setSlideState('out');
          setTimeout(() => {
            setCurrentAnim((prev) => (prev - 1 + heroAnimations.length) % heroAnimations.length);
            setSlideState('in');
          }, 350);
        }}>
          <i className="bi bi-chevron-left"></i>
        </button>

        <button className="hero-arrow hero-arrow-right" onClick={() => {
          setShowButtons(false);
          setSlideState('out');
          setTimeout(() => {
            setCurrentAnim((prev) => (prev + 1) % heroAnimations.length);
            setSlideState('in');
          }, 350);
        }}>
          <i className="bi bi-chevron-right"></i>
        </button>
      </section>

      {/* STATS SECTION */}
      <section className="stats-section py-5">
        <div className="container">
          <div className="row g-4">
            {stats.map((stat, i) => (
              <div className="col-6 col-md-3" key={i} data-aos="zoom-in" data-aos-delay={i * 100}>
                <div className="stat-card text-center">
                  <i className={`bi ${stat.icon} stat-icon`}></i>
                  <h3 className="stat-value">{stat.value}</h3>
                  <p className="stat-label">{stat.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* COURSES SECTION */}
      <section className="py-5">
        <div className="container">
          <div className="text-center mb-5" data-aos="fade-up">
            <h2 className="section-title">Our Courses</h2>
            <p className="section-subtitle">
              From BVoc degrees to professional diplomas, certificates, and micro-credentials —
              flexible routes to build expertise and launch your career.
            </p>
          </div>

          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
            {courses.map((course, i) => (
              <div className="col" key={i} data-aos="fade-up" data-aos-delay={i * 80}>
                <div className="course-card h-100">
                  <img src={cardImg} className="course-card-img" alt={course.title} />
                  <div className="course-card-body">
                    <h5 className="course-card-title">{course.title}</h5>
                    <p className="course-card-text">{course.desc}</p>
                    <Link to="/courses" className="btn-details">
                      More Details <i className="bi bi-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PARTNERS SECTION */}
      <section className="partners-section py-5">
        <div className="container">
          <div className="text-center mb-4" data-aos="fade-up">
            <h2 className="section-title text-white">Professional Collaboration Partners</h2>
          </div>
          <div className="marquee-wrapper" data-aos="zoom-in">
            <div className="marquee-track">
              {repeatedLogos.map((logo, i) => (
                <div className="logo-card" key={i}>
                  <img src={logo.src} alt={logo.alt} />
                </div>
              ))}
              {repeatedLogos.map((logo, i) => (
                <div className="logo-card" key={`dup-${i}`}>
                  <img src={logo.src} alt={logo.alt} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="cta-section py-5">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6" data-aos="fade-right">
              <img src={datacollectionImg} className="img-fluid rounded-4" alt="Join us" />
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <div ref={empowerRef} className="empower-lottie mb-3"></div>
              <h2 className="fw-bold mb-3">Your Future Starts Here</h2>
              <p className="text-muted mb-4">
                Get free career counselling, explore scholarship opportunities, internship
                placements, and download our brochure to discover the perfect program for you.
              </p>
              <div className="cta-buttons">
                <Link to="/contact" className="btn btn-primary-custom me-2 mb-2">
                  <i className="bi bi-download me-2"></i>Download Brochure
                </Link>
                <Link to="/contact" className="btn btn-outline-custom me-2 mb-2">
                  <i className="bi bi-chat-dots me-2"></i>Free Counselling
                </Link>
                <Link to="/contact" className="btn btn-outline-custom mb-2">
                  <i className="bi bi-briefcase me-2"></i>Internships
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* VIDEO SECTION */}
      <section className="py-5">
        <div className="container">
          <div className="text-center mb-4" data-aos="fade-up">
            <h2 className="section-title">Not Just a College… A Launchpad</h2>
            <p className="section-subtitle">
              See how we transform students into industry-ready professionals.
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-10" data-aos="zoom-in">
              <div className="video-wrapper">
                {!showVideo ? (
                  <div className="video-thumbnail" onClick={() => setShowVideo(true)}>
                    <img src={cardImg} alt="Video thumbnail" />
                    <div className="play-btn">
                      <i className="bi bi-play-fill"></i>
                    </div>
                  </div>
                ) : (
                  <div className="ratio ratio-16x9">
                    <iframe
                      src="https://www.youtube-nocookie.com/embed/4y9q55FRpS4?autoplay=1&modestbranding=1&rel=0"
                      title="GEN Skill College"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
